export default __webpack_public_path__ + "static/B2-38bffdea5c8f7c52694ab056b539537b.jpg";